export default __webpack_public_path__ + "static/media/uefach.d33985a6.svg";